import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import AdminInvoice from "../../components/InvoiceReport/AdminInvoice";
import { Roles } from "../../helper/userHelper";
import Level_1 from "../../pages/Accounts/AccountsLevel/LevelOne";
import Level_3 from "../../pages/Accounts/AccountsLevel/LevelThree";
import Level_2 from "../../pages/Accounts/AccountsLevel/LevelTwo";
import CashBook from "../../pages/Accounts/CashBook";
import Ledger from "../../pages/Accounts/Ledger";
import OpeningBalance from "../../pages/Accounts/OpeningBalance";
import TrialBalance from "../../pages/Accounts/TrialBalance";
import Voucher from "../../pages/Accounts/Voucher";
import SearchVoucher from "../../pages/Accounts/Voucher/searchVoucher";
import CreateOrder from "../../pages/CreateOrder";
import Dashboard from "../../pages/Dashboard/Dashboard";
import DashboardOrders from "../../pages/Dashboard/DashboardOrders";
import DashboardProduct from "../../pages/Dashboard/DashboardProduct";
import { Departments } from "../../pages/Departments";
import Home from "../../pages/Home";
import { default as RawInventory } from "../../pages/Inventory/RawInventory";
import Recipe from "../../pages/Inventory/Recipe";
import Suppliers from "../../pages/Inventory/Supplier";
import Production from "../../pages/Inventory/production";
import { Products } from "../../pages/Products";
import { RawMaterialStore } from "../../pages/RawMaterialsStore";
import Orders from "../../pages/Reports";
import OrderStatus from "../../pages/Status";
import ComplainTask from "../../pages/complainTask";
import Setting from "../../pages/setting";
import AccountSetting from "../../pages/setting/tabs/Account Setting";
//import Payment from "../../pages/setting/tabs/Payment";
import Customer from "../../pages/Customers/Customer";
import { PaymentPage } from "../../pages/Payment";
import { loggedIn } from "../../store/reducer/currentUserSlice";
import LoginForm from "../LoginOut/LoginForm";
import Auth from "./Auth";
import { Footer } from "./Footer";
import Navbar from "./Navbar";
import Loader from "../LoginOut/Loader"; // Import the Loader component

const RoutingComp = () => {
  const auth = useSelector((state) => state.currentUser.authToken);
  const location = useLocation();
  const showNavbar = location.pathname !== "/login";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // State to manage loading state

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAction = async () => {
    setLoading(true); // Start loading when action is initiated
    const authentication = getAuth();

    try {
      const response = await signInWithEmailAndPassword(authentication, email, password);
      const userRoleRef = doc(db, "Users", response.user.uid);
      let userData = await getDoc(userRoleRef);
      console.log(userData.data());

      userData = userData.data();
      dispatch(
        loggedIn({
          role: userData.role,
          name: userData.name,
          authToken: response._tokenResponse.refreshToken,
        })
      );
      navigate("/home");
    } catch (error) {
      console.log(error);
      if (error.code === "auth/wrong-password") {
        toast.error("Please check the Password");
      }
      if (error.code === "auth/user-not-found") {
        toast.error("Please check the Email");
      }
    } finally {
      setLoading(false); // Stop loading regardless of success or error
    }
  };

  if (loading) {
    return <Loader />; // Show the loader component while loading
  }

  return (
    <>
      {auth && <Navbar />}

      <Routes>
        <Route
          path="/login"
          element={
            <LoginForm
              title="Login"
              setEmail={setEmail}
              setPassword={setPassword}
              handleAction={handleAction}
            />
          }
        />
        <Route
          path="/"
          element={
            auth ? (
              <Home />
            ) : (
              <LoginForm
                title="Login"
                setEmail={setEmail}
                setPassword={setPassword}
                handleAction={handleAction}
              />
            )
          }
        />
        <Route path="/home" element={<Home />} />

        {/* Protected Routes */}
        <Route
          element={
            <Auth
              allowedRoles={[
                Roles.Supervisor,
                Roles.Accountant,
                Roles.InventoryOfficer,
                Roles.Salesman,
                Roles.CEO,
                Roles.Customer,
              ]}
            />
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/Create Order" element={<CreateOrder />} />
          <Route path="/orderstatus" element={<OrderStatus />} />
          <Route path="/invoice" element={<AdminInvoice />} />
        </Route>
        <Route
          element={
            <Auth
              allowedRoles={[
                Roles.Supervisor,
                Roles.Accountant,
                Roles.InventoryOfficer,
                Roles.CEO,
              ]}
            />
          }
        ></Route>

        <Route
          element={
            <Auth
              allowedRoles={[Roles.Supervisor, Roles.Accountant, Roles.CEO]}
            />
          }
        >
          <Route path="/trial-balance" element={<TrialBalance />} />
          <Route path="/cash-book" element={<CashBook />} />
          <Route path="/level-one" element={<Level_1 />} />
          <Route path="/level-two" element={<Level_2 />} />
          <Route path="/level-three" element={<Level_3 />} />
          <Route path="/opening-balance" element={<OpeningBalance />} />
          <Route path="/voucher" element={<Voucher />} />
          <Route path="/search-voucher" element={<SearchVoucher />} />
          <Route path="/ledger" element={<Ledger />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/Inventory" element={<Production />} />
          <Route path="/rawInventory" element={<RawInventory />} />
          <Route path="/recipe" element={<Recipe />} />
          <Route path="/accountSetting" element={<AccountSetting />} />
        </Route>

        <Route
          element={
            <Auth
              allowedRoles={[Roles.Supervisor, Roles.CEO]}
            />
          }
        >
          <Route path="/reports" element={<Orders />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/products" element={<Products />} />
          <Route path="/dashboardProducts" element={<DashboardProduct />} />
          <Route path="/dashbordOrders" element={<DashboardOrders />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/Issues" element={<ComplainTask />} />
          <Route path="/customers" element={<Customer />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/raw-material" name="Raw Material" element={<RawMaterialStore />} />
        </Route>
      </Routes>
      {auth && <Footer />}
    </>
  );
};

export default RoutingComp;
